import React, { useEffect, useState, Fragment, useRef } from "react";
import { SearchIcon } from "@heroicons/react/solid";
import { DocumentDownloadIcon } from "@heroicons/react/outline";
import Layout from "../../components/Layout/Layout";
import AccountServices from "../../services/AccountServices";
import Paginate from "../../utils/Paginate";
import { convert, formatDate, DisplayTime } from "./../../utils/convertDate";
import DatePicker from "react-date-picker";
import { Dialog, Transition } from "@headlessui/react";
import { HollowDotsSpinner } from "react-epic-spinners";
import fire from "../../utils/Toastr";
import CustomerServices from "../../services/CustomerServices";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

export default function UserAccounts() {
  const [accounts, setAccount] = useState([]);
  const [search, setSearch] = useState("");
  const [pageIndex, setPageIndex] = useState(1);
  const [prevPage, setPrev] = useState(false);
  const [pageNumber, setPageNumber] = useState(1);
  const [totalPage, setPage] = useState(0);
  const [nextPage, setNextPage] = useState(false);
  const [from, setFrom] = useState("");
  const [to, setTo] = useState("");
  const [pageLength, setPageLength] = useState("");
  const oldFrom = new Date().setDate(new Date().getDate() - 7);
  const [formValues, setFormValues] = useState({
    from: new Date(oldFrom),
    to: new Date(),
  });
  const errors = {
    commentError: "",
    commentIsValidated: false,
    formIsSubmitting: false,
  };
  const defaultTo = formatDate(new Date());
  const longNew = formatDate(defaultTo);
  const [too, setToo] = useState(convert(longNew));
  const defaultFrom = formatDate(new Date().setDate(new Date().getDate() - 7));
  const longDate = formatDate(defaultFrom);
  const [fromm, setFromm] = useState(convert(longDate));
  const cancelButtonRef = useRef(null);
  const [open, setOpen] = useState(false);
  const [formState, setFormState] = useState(errors);
  const [adminType, setAdminType] = useState("");
  const [accountNumber, setAccountNumber] = useState("");
  const [commentValue, setCommentValue] = useState({
    comment: "",
  });
  const [loading, setLoading] = useState(false);

  const handleApprove = async (accountNo) => {
    setAccountNumber(accountNo);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  // unblock account
  const unblockAccount = async () => {
    let user = accounts.find((x) => x.accountNumber === accountNumber);
    if (adminType.toLowerCase() === "maker") {
      const response = await CustomerServices.unblockAccount({
        accountNumber: accountNumber,
      });
      if (response) {
        fire("success", response.message);
        setTimeout(() => {
          window.location.reload();
        }, 5000);
        setLoading(false);
      }
    }

    if (adminType.toLowerCase() === "checker") {
      const response = await CustomerServices.unblockAccount({
        accountNumber: accountNumber,
      });
      if (response) {
        fire("success", response.message);
        setTimeout(() => {
          window.location.reload();
        }, 5000);
        setLoading(false);
      }
    }
  };

  const listAccount = async () => {
    const account = await AccountServices.listUserAccount(
      pageIndex,
      10,
      search,
      fromm,
      too
    );
    setAccount([...account.data.result]);
    setPageLength([...account.data.result].length);
    setPageNumber(account.data.totalCount);
    setPageIndex(account.data.pageIndex);
    setPrev(account.data.hasPreviousPage);
    setPage(account.data.totalPages);
    setNextPage(account.data.hasNextPage);
  };
  const searchAccount = async (text) => {
    setSearch(text);
  };

  const range = async (e) => {
    e.preventDefault();
    const newDate = formatDate(formValues.from);
    setFrom(formValues.from);
    var longDate = formatDate(newDate);
    setFromm(convert(longDate));

    const toDate = formatDate(formValues.to);
    setTo(formValues.to);
    setToo(convert(toDate));

    const account = await AccountServices.listUserAccount(
      1,
      10,
      search,
      convert(newDate),
      convert(toDate)
    );
    setAccount([...account.data.result]);
    setPageLength([...account.data.result].length);
    setPageNumber(account.data.totalCount);
    setPageIndex(account.data.pageIndex);
    setPrev(account.data.hasPreviousPage);
    setPage(account.data.totalPages);
    setNextPage(account.data.hasNextPage);
  };
  const dateValidation = {
    fromHandler: (event) => {
      setFormValues({ ...formValues, from: event });
    },
    toHandler: (event) => {
      setFormValues({ ...formValues, to: event });
    },
  };

  const handleExport = async () => {
    const resp = await AccountServices.exportUserAccount(search, fromm, too);
    window.open(resp.data);
  };
  useEffect(() => {
    listAccount();
    var details = sessionStorage.getItem("user");
    var userDetails = JSON.parse(details);
    var type = userDetails.adminType;
    setAdminType(type);
  }, [pageIndex]);
  return (
    <>
      <Layout
        title="User Accounts"
        pageTag={"account"}
        current={"/user/accounts"}
      >
        <React.Fragment>
          <main>
            <div className="max-w-7xl mx-auto ">
              <div className="">
                <div className="">
                  <div className="mt-5 sm:ml-16 flex justify-end">
                    <button
                      type="button"
                      onClick={handleExport}
                      className="mr-2 inline-flex active:text-white items-center justify-center rounded-md border border-transparent hover:text-white btn-green px-3 py-2 text-sm font-medium text-green shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:w-auto"
                    >
                      <DocumentDownloadIcon className="w-4 mr-1.5" />
                      Export CSV
                    </button>
                  </div>
                  <div className="sm:flex sm:items-center">
                    <div className="sm:flex-auto flex">
                      <div className=" relative rounded-md shadow-sm ml-3">
                        <p className="text-sm leading-3 text-gray-500">From</p>
                        <div>
                          <DatePicker
                            onChange={dateValidation.fromHandler}
                            value={formValues.from}
                          />
                        </div>
                      </div>
                      <div className=" relative rounded-md shadow-sm ml-3">
                        <p className="text-sm leading-3 text-gray-500">To</p>
                        <div>
                          <DatePicker
                            onChange={dateValidation.toHandler}
                            value={formValues.to}
                          />
                        </div>
                      </div>
                      <div className="mt-5 ml-4 relative rounded-md shadow-sm">
                        <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                          <SearchIcon
                            className="h-5 w-5 text-gray-400"
                            aria-hidden="true"
                          />
                        </div>
                        <input
                          type="text"
                          name="user"
                          id="user"
                          onChange={(e) => searchAccount(e.target.value)}
                          className="focus:ring-indigo-500 focus:border-indigo-500 block w-full pl-10 sm:text-sm border-gray-300 rounded-md"
                          placeholder="Search account"
                        />
                      </div>
                      <div className="mt-5 ml-4">
                        <button
                          onClick={range}
                          className="hover:text-white active:text-white inline-flex mr-2 items-center justify-center rounded-md border border-transparent btn-green px-6 py-2 text-sm font-medium text-green shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:w-auto"
                        >
                          Search
                        </button>
                      </div>
                    </div>
                  </div>
                  {accounts.length === 0 ? (
                    <div className="mt-8">
                      {" "}
                      No data available for these dates to show.{" "}
                    </div>
                  ) : (
                    <>
                      <div className="mt-8 flex ">
                        <div className="-my-2  overflow-x-auto ">
                          <div className="inline-block min-w-full py-2 align-middle">
                            <div className="relative h-screen  ring-black ring-opacity-5 md:rounded-lg">
                              <table className="min-w-full table-fixed divide-y divide-gray-300">
                                <thead>
                                  <tr>
                                    <th
                                      scope="col"
                                      className="min-w-[8rem] py-3.5 pr-3 italic font-normal text-left text-sm text-gray-500"
                                    >
                                      Account Number
                                    </th>
                                    <th
                                      scope="col"
                                      className="min-w-[8rem] py-3.5 pr-3 italic font-normal text-left text-sm text-gray-500"
                                    >
                                      Account Name
                                    </th>
                                    <th
                                      scope="col"
                                      className="min-w-[8rem]  py-3.5 text-left text-sm italic font-normal text-gray-500"
                                    >
                                      Account Currency
                                    </th>
                                    <th
                                      scope="col"
                                      className="min-w-[8rem] px-3 py-3.5 text-left text-sm italic font-normal text-gray-500"
                                    >
                                      Account Type
                                    </th>
                                    <th
                                      scope="col"
                                      className="min-w-[8rem] px-3 py-3.5 text-left text-sm italic font-normal text-gray-500"
                                    >
                                      Account Category
                                    </th>
                                    <th
                                      scope="col"
                                      className="min-w-[8rem] px-3 py-3.5 text-left text-sm italic font-normal text-gray-500"
                                    >
                                      PND Restriction
                                    </th>
                                    <th
                                      scope="col"
                                      className="min-w-[8rem] px-3 py-3.5 text-left text-sm italic font-normal text-gray-500"
                                    >
                                      Account Status
                                    </th>
                                    <th
                                      scope="col"
                                      className="min-w-[8rem] px-3 py-3.5 text-left text-sm italic font-normal text-gray-500"
                                    >
                                      Account Blocked
                                    </th>
                                    <th
                                      scope="col"
                                      className="min-w-[8rem] px-3 py-3.5 text-left text-sm italic font-normal text-gray-500"
                                    >
                                      Joint Account Indicator
                                    </th>
                                    <th
                                      scope="col"
                                      className="min-w-[8rem] px-3 py-3.5 text-left text-sm italic font-normal text-gray-500"
                                    >
                                      Date Account Opened
                                    </th>
                                    <th
                                      scope="col"
                                      className="min-w-[8rem] px-3 py-3.5 text-left text-sm italic font-normal text-gray-500"
                                    >
                                      Time Created
                                    </th>
                                    <th
                                      scope="col"
                                      className="min-w-[8rem] px-3 py-3.5 text-left text-sm italic font-normal text-gray-500"
                                    >
                                      Account Officer
                                    </th>
                                    <th
                                      scope="col"
                                      className="min-w-[8rem] px-3 py-3.5 text-left text-sm italic font-normal text-gray-500"
                                    >
                                      Action
                                    </th>
                                  </tr>
                                </thead>
                                <tbody className="divide-y divide-gray-200 bg-white">
                                  {accounts.map((person, i) => (
                                    <tr key={i} className="bg-gray-50">
                                      <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">
                                        {person.accountNumber}{" "}
                                      </td>
                                      <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">
                                        {person.accountName}{" "}
                                      </td>
                                      <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">
                                        {person.currency}
                                      </td>
                                      <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">
                                        {person.accountType}
                                      </td>
                                      <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">
                                        {person.accountCategory}
                                      </td>
                                      <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">
                                        {person.accountOnPnd}
                                      </td>
                                      <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">
                                        {person.accountStatus}
                                      </td>
                                      <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">
                                        {person.isBlocked === true
                                          ? "Blocked"
                                          : "Not Blocked"}
                                      </td>
                                      <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">
                                        {person.jointAcIndicator}
                                      </td>
                                      <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">
                                        {formatDate(person.dateCreated)}
                                      </td>
                                      <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">
                                        {DisplayTime(person.dateCreated)}
                                      </td>
                                      <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">
                                        {person.introducerMis === ""
                                          ? "N/A"
                                          : person.introducerMis}
                                      </td>
                                      <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">
                                        {person.unblockUserAccountStatus ===
                                          "Initiated" &&
                                        adminType.toLowerCase() === "maker" ? (
                                          <p>Unblock Initiated</p>
                                        ) : (
                                          <button
                                            className="block text-sm text-[#FF0000]"
                                            type="button"
                                            disabled={!person.isBlocked}
                                            onClick={() =>
                                              handleApprove(
                                                person.accountNumber
                                              )
                                            }
                                          >
                                            {person.isBlocked
                                              ? "Unblock Account"
                                              : "Block Account"}
                                          </button>
                                        )}
                                      </td>
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </div>
                      <Paginate
                                    nextPage={nextPage}
                                    pageIndex={pageIndex}
                                    totalCount={pageNumber}
                                    totalPages={totalPage}
                                    prevPage={prevPage}
                                    setPageIndex={setPageIndex}
                                />
                    </>
                  )}
                </div>
              </div>
            </div>
          </main>

          {/* Approve modal */}
          <Transition.Root show={open} as={Fragment}>
            <Dialog
              as="div"
              className="relative z-10"
              initialFocus={cancelButtonRef}
              onClose={handleClose}
            >
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0"
                enterTo="opacity-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100"
                leaveTo="opacity-0"
              >
                <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
              </Transition.Child>

              <div className="fixed z-10 inset-0 overflow-y-auto">
                <div className="flex items-end sm:items-center justify-center min-h-full p-4 text-center sm:p-0">
                  <Transition.Child
                    as={Fragment}
                    enter="ease-out duration-300"
                    enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                    enterTo="opacity-100 translate-y-0 sm:scale-100"
                    leave="ease-in duration-200"
                    leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                    leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                  >
                    <Dialog.Panel className="relative bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:max-w-xs sm:w-full sm:p-6">
                      <div>
                        <div className="mt-3 text-center sm:mt-5">
                          <Dialog.Title
                            as="h3"
                            className="text-lg leading-6 font-medium text-gray-900"
                          >
                            Hey, wait!!
                          </Dialog.Title>
                          <div className="mt-2">
                            <p className="text-sm text-gray-500">
                              Are you sure you want to unblock this account?
                            </p>
                          </div>
                        </div>
                      </div>
                      <div className="mt-5 sm:mt-6 sm:flex sm:grid-cols-2 sm:gap-3 sm:grid-flow-row-dense">
                        {loading ? (
                          <HollowDotsSpinner size={15} color="#4D627E" />
                        ) : (
                          <button
                            type="button"
                            className="w-full inline-flex justify-center rounded-md border border-gray-900 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-900  sm:col-start-2 sm:text-sm"
                            onClick={() => {
                              setLoading(true);
                              unblockAccount();
                            }}
                          >
                            Yes, I do
                          </button>
                        )}

                        <button
                          type="button"
                          className="mt-3 w-full inline-flex justify-center rounded-md border bg-dark border-gray-300 shadow-sm px-4 py-2  text-base font-medium text-white btn-primary sm:mt-0 sm:col-start-1 sm:text-sm"
                          onClick={() => setOpen(false)}
                          ref={cancelButtonRef}
                        >
                          No, I don't
                        </button>
                      </div>
                    </Dialog.Panel>
                  </Transition.Child>
                </div>
              </div>
            </Dialog>
          </Transition.Root>
        </React.Fragment>
      </Layout>
    </>
  );
}
